import {Carousel, Tag, Button, Modal, Calendar, TimePicker}         from 'antd';
import moment                                                       from 'moment/moment';
import React, {useState, useEffect}                                 from 'react';
import "./details.scss";
import { EnvironmentFilled, HeartOutlined, HeartFilled, EyeFilled } from '@ant-design/icons';
import { WMSTileLayer, Marker, Popup, MapContainer }                from 'react-leaflet';
import {ReactComponent as Plane}                                    from '../../assets/icons/plane.svg';
import {
    addToFavApi
}                                                                   from '../../reuseableComponents/CardComponent/apis/apis';
import {useNavigate}                                                from 'react-router-dom';
import {useParams}                                                  from 'react-router-dom';
import Notification                                                 from '../../reuseableComponents/Notification';
import {createConversation}                                         from '../conversation/apis/apis';
import {getPropertyByIdApi}                                         from './apis/apis';
import {createHomeTourRequests}                                     from "../requestHomeTour/apis/apis";

const format = 'HH:mm';

const Details = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [state, setState] = useState({
        details: null,
        stop: true,
        user: {},
        selectedDate: null,
        selectedTime: null,
        position: []
    })

    const {id} = useParams();


    const contentStyle = {
        height: '160px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#364d79',
    };

    const navigate = useNavigate()

    const getPropertyFunction = async () => {
        try {
            let result = await getPropertyByIdApi(id)
            if (result?.status) {
                setState({
                    ...state,
                    details: result.data.data,
                    user: result.data.data?.user,
                    position: [result?.data?.data?.latitude, result?.data?.data?.longitude]
                })
            } else {
                Notification('error', "Error", "Error.");
            }
        } catch (err) {
            Notification('error', "Error", "Error.");
        }
    }

    const saveProperty = async () => {
        try {
            let result = await addToFavApi({propertyId: id})
            if (result?.status) {
            } else {
                Notification('error', "Error", "Error.");
            }
        } catch (err) {
            Notification('error', "Error", "Error.");
        }
    };

    useEffect(() => {
        getPropertyFunction()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.stop]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const onDateChange = (date) => {
        setState({...state, selectedDate: date});
    };

    const onTimeChange = (time) => {
        setState({...state, selectedTime: time});
    };

    const handleRequest = async () => {
        if (!state.selectedDate || !state.selectedTime) {
            console.warn("Please select both date and time");
            return;
        }

        const formattedDate = state.selectedDate.format("YYYY-MM-DD");
        const formattedTime = state.selectedTime.format("HH:mm");

        console.log("Selected Date:", formattedDate);
        console.log("Selected Time:", formattedTime);

        await createHomeTourRequests({
            propertyId: id,
            tourDate: formattedDate,
            tourTime: formattedTime,
        })

        Notification("success", "Request Sent Successfully");
        setIsModalOpen(false);
    };

    let isLoggedIn = localStorage.getItem("token") && localStorage.getItem("userLogin");

    return <div className={"all-container-details"} style={{
        paddingTop: "5%"
    }}>
        <div className={"details-hero"}>
            <div className={"left"}>
                <Carousel autoplay>
                    {state.details?.photos?.length > 0 &&
                      state.details.photos.map((ig, index) => (
                        <img
                          key={index}
                          src={ig}
                          alt="house"
                        />
                      ))}
                </Carousel>

            </div>
            <div className={"right"}>
                <div className={"heading"}>
                    <div>
                        <h1>{state?.details?.title}</h1>
                        <p><EnvironmentFilled
                            style={{color: "#246BFD", fontSize: 12, marginRight: 6}}/>{state.details?.address + !!state.details?.city ? state.details?.city : "" }</p>
                    </div>
                    <div className={"tags-container"}>
                        <Tag bordered={false} color={"green"}>
                          Published at  {moment(state.details?.createdAt).format("DD/MM/YYYY")}
                        </Tag>
                        <Tag bordered={false} color={"orange"}>
                            {!!state.details?.isForSale ? "For Sale" : "For Rent"}
                        </Tag>
                        <Tag bordered={false} color={"red"}>
                            <HeartFilled/> {state.details?.favoritesCount}
                        </Tag>
                        <Tag bordered={false} color={"blue"}>
                            <EyeFilled/> {state.details?.recentViewsCount}
                        </Tag>
                        {
                          state.details?.type && <Tag bordered={ false } color="processing">
                            { state.details?.type }
                        </Tag>
                        }
                    </div>
                </div>
                <h3 className={"heading-includes"}>Includes</h3>
                <p className={"description-includes"}>
                    {state?.details?.description}
                </p>
                <h3 className={"heading-includes"}>Features</h3>
                <div className={"list-option"}>
                    <div>Beds : {state.details?.beds ? state.details?.beds : 0}</div>
                    <div>Baths: {state.details?.baths ? (state.details?.baths || state.details?.fullBaths) : 0}</div>
                    <div>Gym: {state.details?.gym ? "Yes" : "No"}</div>
                    <div>Laundary Room: {state.details?.laundryRoom ? "Yes" : "No"}</div>
                    <div>Pool: {state.details?.pool ? "Yes" : "No"}</div>
                    <div>Dining Room: {state.details?.diningRoom ? "Yes" : "No"}</div>
                    <div>Elevator: {state.details?.elevator ? "Yes" : "No"}</div>
                </div>
                <h3 className={"heading-includes"}>Owner</h3>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    fontWeight: 700,
                    fontSize: 18,
                    color: "#1E1E1E",
                    marginTop: 16
                }}>
                    { state?.user?.photo && <img style={ {
                        height: 40,
                        width: 40,
                        borderRadius: 20,
                        border: "1px solid",
                        objectFit: "cover"
                    } } src={ state?.user?.photo } alt="person"/> }
                    {state?.details?.user?.name || state?.details?.user?.email}
                </div>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 20
                }}>
                    <h4 className={"heading-includes"} style={{
                        marginTop: 0
                    }}>Total</h4>
                    <span style={{
                        color: "#1677ff",
                        fontWeight: 700,
                        fontSize: 18,
                        marginTop: 0
                    }}>${state.details?.price}</span>
                    {/*<span style={ {*/}
                    {/*  color: "#1677ff",*/}
                    {/*  fontWeight: 700,*/}
                    {/*  fontSize: 18,*/}
                    {/*  marginTop: 0*/}
                    {/*} }>$1,900 <span style={ {*/}
                    {/*  color: "grey",*/}
                    {/*  fontSize: 12,*/}
                    {/*  fontWeight: 1000*/}
                    {/*} }>/Month</span></span>*/}
                </div>

                <div className={"button"}>
                    {/*<Button size="large" type="primary">*/}
                    {/*  Pre-Qualify*/}
                    {/*</Button>*/}
                    {state.details?.user?.email !== localStorage.getItem("user") && <Button onClick={() => setIsModalOpen(true)} size="large" type="primary">
                        Request home tour
                    </Button>}
                    {/*{state.details?.user?.email !== localStorage.getItem("user") &&*/}
                    {/*    <Button disabled={!isLoggedIn}  onClick={saveProperty} size="large" type="primary">*/}
                    {/*        <HeartOutlined style={{color: isLoggedIn ? "white" : "grey", fontSize: 16}}/>*/}
                    {/*        Save*/}
                    {/*    </Button>*/}
                    {/*}*/}


                    {/*{state.details?.user?.email !== localStorage.getItem("user") && <Button onClick={() => navigate(`/requestHomeTour/${state.details?.id}`)} size="large"*/}
                    {/*         type="primary">*/}
                    {/*    <Plane/>*/}
                    {/*</Button>}*/}

                    {state.details?.user?.email === localStorage.getItem("user") &&
                        <Button onClick={() => navigate(`/updateProperty/${id}`)}
                                size="large"
                                type="primary">
                        Edit
                    </Button>}
                </div>
                {state.details?.user?.email !== localStorage.getItem("user") && <div className={"button"} style={{
                    width: "100%"
                }}>
                    <Button disabled={!isLoggedIn} onClick={async () => {
                        await createConversation(state.user.id)
                        navigate("/conversation")
                    }} style={{
                        width: "100%"
                    }} size="large" type="primary">
                        Contact
                    </Button>
                </div>}
            </div>
        </div>
        <div style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 700,
            fontSize: 18,
            color: "#1E1E1E",
            marginTop: 16
        }}>
            {
              state?.user?.photo && <img style={ {
                height: 40,
                width: 40,
                borderRadius: 20,
                border: "1px solid",
                objectFit: "cover"
            } } src={ state?.user?.photo } alt="person"/> }
            {state.details?.user?.name || state.details?.user?.email}
        </div>
        <p style={{
            marginTop: 14
        }}>
            {
                state.details?.user?.description
            }
        </p>

        <br/>
        <br/>

        {
            state?.position?.length > 0 &&
          <MapContainer center={ state?.position && state?.position } zoom={ 13 } scrollWheelZoom={false}
                        style={ { height: "60vh", width: "100%" } }>
            <WMSTileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={ state.position && state.position }>
            </Marker>
        </MapContainer>
        }

        <Modal
            title="Request home tour"
            onCancel={() => setIsModalOpen(false)}
            open={isModalOpen}
            footer={false}
        >
            <p>Select a date and time to see the property</p>
            <div>
                <Calendar fullscreen={false} onSelect={onDateChange}/>
            </div>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 20,
                }}
            >
                <h5>Time</h5>
                <TimePicker
                    value={state.selectedTime}
                    onChange={onTimeChange}
                    defaultValue={moment("12:08", format)}
                    format={format}
                />
            </div>
            <p style={{marginTop: 10}}>An expert will contact you shortly.</p>
            <Button
                type="primary"
                style={{width: "100%", marginTop: 10}}
                onClick={handleRequest}
            >
                Request
            </Button>
        </Modal></div>
}

export default Details